/* eslint-disable react/no-array-index-key */
import { useTranslation } from "react-i18next";

import { noDp } from "@/helpers/helpers";
import useAppStore from "@/store/appStateZustand";
import { useUIStateStore } from "@/store/uiStateStore";

function TabSongs({ result }) {
  const currencySymbol = useAppStore(s => s.tenantCurrencySymbol);
  const { t } = useTranslation("other");
  let songs = [];
  if (result?.body?.aggregations?.Songs) {
    songs = result?.body?.aggregations?.Songs.buckets.slice(0, 5);
  }

  const isTunecore = useUIStateStore(state => state.isTunecore);

  return (
    <div className="flex flex-col items-start h-full p-4">
      <h1 className={`text-md xl:text-xl font-medium ${isTunecore ? "text-white" : "text-black"} lg:mb-4`}>{t("other:songs-tab-header")}</h1>
      {songs.map((s, i) => (
        <div className={`h-14 gap-1 ${i < (songs.length - 1) ? "border-b" : ""} flex w-full items-center justify-between font-sentric-alt`} key={`song${i}`}>
          <div className="flex flex-row text-xs font-semibold">
            <span className="flex-none w-4 h-4 mr-2 text-xs text-white rounded-full bg-layer-raised">{(i + 1)}</span>
            <span className="text-left line-clamp-2 break-word">
              {s.SongTitle.buckets[0].key}
            </span>
          </div>
          <div className={`${isTunecore ? "text-white" : "text-black "} font-medium text-xs`}>
            {currencySymbol}
            {noDp(s.SongValues.value)}
          </div>

        </div>
      ))}
    </div>
  );
}

export default TabSongs;
